import { tagRecording } from './tools/hotjar';

/**
 * Tag a Hotjar recording with multiple tags.
 */
export function multipleRecordingTags(name: string, tags: Array<string | number | boolean>): void {
  tags.forEach((tag) => {
    tagRecording(`${name}: ${tag}`);
  });
}
